module.exports = {
	"textures": [
		{
			"image": "GameMenu",
			"format": "RGBA8888",
			"size": {
				"w": 625,
				"h": 495
			},
			"scale": 1,
			"frames": [
				{
					"filename": "winnumberhistorymask.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 265,
						"h": 265
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 265,
						"h": 265
					},
					"frame": {
						"x": 2,
						"y": 2,
						"w": 265,
						"h": 265
					}
				},
				{
					"filename": "Logo_IMAXA.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 352,
						"h": 133
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 352,
						"h": 133
					},
					"frame": {
						"x": 271,
						"y": 2,
						"w": 352,
						"h": 133
					}
				},
				{
					"filename": "MenuIcon_PreviousPage.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 112,
						"h": 224
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 112,
						"h": 224
					},
					"frame": {
						"x": 271,
						"y": 139,
						"w": 112,
						"h": 224
					}
				},
				{
					"filename": "MenuButton_Clicked.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 126,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 126,
						"h": 82
					},
					"frame": {
						"x": 2,
						"y": 271,
						"w": 126,
						"h": 82
					}
				},
				{
					"filename": "MenuButton_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 126,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 126,
						"h": 82
					},
					"frame": {
						"x": 132,
						"y": 271,
						"w": 126,
						"h": 82
					}
				},
				{
					"filename": "MenuButton_Hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 126,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 126,
						"h": 82
					},
					"frame": {
						"x": 2,
						"y": 357,
						"w": 126,
						"h": 82
					}
				},
				{
					"filename": "MenuButton_Normal.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 126,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 126,
						"h": 82
					},
					"frame": {
						"x": 132,
						"y": 357,
						"w": 126,
						"h": 82
					}
				},
				{
					"filename": "cancelButton.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 126,
						"h": 61
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 126,
						"h": 61
					},
					"frame": {
						"x": 262,
						"y": 367,
						"w": 126,
						"h": 61
					}
				},
				{
					"filename": "confirmButton.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 126,
						"h": 61
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 126,
						"h": 61
					},
					"frame": {
						"x": 262,
						"y": 432,
						"w": 126,
						"h": 61
					}
				},
				{
					"filename": "unlockButton.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 126,
						"h": 61
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 126,
						"h": 61
					},
					"frame": {
						"x": 387,
						"y": 139,
						"w": 126,
						"h": 61
					}
				},
				{
					"filename": "upgradeIcon.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 66,
						"h": 66
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 66,
						"h": 66
					},
					"frame": {
						"x": 387,
						"y": 204,
						"w": 66,
						"h": 66
					}
				},
				{
					"filename": "MenuBackground.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 387,
						"y": 274,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "MenuIcon_Chat.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 392,
						"y": 342,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "MenuIcon_Fullscreen.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 455,
						"y": 274,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "MenuIcon_History.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 457,
						"y": 204,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "MenuIcon_Logout.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 392,
						"y": 410,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "MenuIcon_Repeat.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 523,
						"y": 272,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "MenuIcon_Settings.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 525,
						"y": 139,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "MenuIcon_Statistics.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 523,
						"y": 340,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "MenuIcon_Volume.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 460,
						"y": 408,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "MenuIcon_Withdraw.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 528,
						"y": 408,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "MenuIcon_Close.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 56,
						"h": 56
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 56,
						"h": 56
					},
					"frame": {
						"x": 460,
						"y": 342,
						"w": 56,
						"h": 56
					}
				},
				{
					"filename": "MenuButtonIcon_Menu.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 48,
						"h": 44
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 44
					},
					"frame": {
						"x": 525,
						"y": 207,
						"w": 48,
						"h": 44
					}
				},
				{
					"filename": "MenuButtonIcon_Help.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 35,
						"h": 47
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 35,
						"h": 47
					},
					"frame": {
						"x": 577,
						"y": 207,
						"w": 35,
						"h": 47
					}
				},
				{
					"filename": "Menu_SliderImage.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 32,
						"h": 32
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 32,
						"h": 32
					},
					"frame": {
						"x": 591,
						"y": 258,
						"w": 32,
						"h": 32
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
};